// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nlabel[data-v-cd766dfe] {\n  cursor: pointer;\n  color: #007eff;\n  font-size: var(--x-small);\n  font-weight: 200;\n}\n.logo[data-v-cd766dfe] {\n  max-width: 300px;\n  max-height: 200px;\n}\n.upload-logo[data-v-cd766dfe] {\n  opacity: 0;\n  position: absolute;\n  z-index: -1;\n}\n", ""]);
// Exports
module.exports = exports;
